import styled from 'styled-components';
import COLORS from 'constants/colors';

export const BaseAvatar = styled.div`
  font-family: Inter;
  font-size: 40px;
  font-weight: 700;
  line-height: 1;
  text-align: center;

  width: 64px;
  height: 64px;

  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border-radius: 50%;
  overflow: hidden;
  color: ${COLORS.WHITE};
  background-color: ${COLORS.FINCH.BLACK};
`;
